import { AddressFragment } from 'src/legacy_graphql'
import { useAccount, useActions, useCallback, useMutations } from 'src/hooks'

const useRevertBulkOrder = () => {
  const account = useAccount()
  const mutations = useMutations()
  const actions = useActions()

  return useCallback(
    async (orderId: string) => {
      const { revertBulkOrder } = await mutations.revertBulkOrder({
        id: orderId,
      })
      if (revertBulkOrder.order) {
        actions.savedOrder(revertBulkOrder.order)
      }

      if (account.shippingAddress) {
        const returnAddress: AddressFragment = {
          __typename: 'Address',
          firstName: account.shippingAddress.firstName,
          lastName: account.shippingAddress.lastName,
          company: account.shippingAddress.company,
          address1: account.shippingAddress.address1,
          address2: account.shippingAddress.address2,
          city: account.shippingAddress.city,
          state: account.shippingAddress.state,
          postalCode: account.shippingAddress.postalCode,
          country: account.shippingAddress.country,
        }
        const { updateOrder } = await mutations.updateOrder({
          order: { id: orderId, returnAddress: returnAddress },
        })

        if (updateOrder.order) {
          actions.savedOrder(updateOrder.order)
        }
      }
    },
    [account, mutations, actions],
  )
}
export default useRevertBulkOrder
